<template>
 <div style="width: 100%;height:100%">
  <img
    alt
    style="width: 100%;"
    :style="{height:height}"
    :src="imgSrc"
  />
 </div>


</template>
<script>
export default{
  name:'refreshImg',
  props:{
    imgUrl:{
      type:String,
      
    },
    stopImg:{ //定格图片地址
      type:String,
      
    },
    //间隔每次动画播放
    duration:{
      type:Number,
      default(){
        return 3000
      }
    },
    flag:{
      type:Number,
      default:()=>1
    },
    imgSize:{
      type:String,
      default:()=>'小'
    },
    imgName:{
      type:String,
    },
    //多少秒开始执行
    startTime:{
      type:Number
    },
    immediately:{ //是否立即执行
      type:Boolean,
      default:true
    },
    playCount:{
      type:Number
    },
    height:{
      type:String,
      default:()=>''
    }
  },
  data(){
    return{
      imgSrc:'',
      lastTime:0,
      count :0,
    }
  },
  methods:{
    computedUrl(){
      const time =new Date().getTime();
      if(this.imgUrl ){
        return `${require(`@/assets/image/${this.imgUrl}`)}?${time}`
      }
      const typeMap ={
        1:'上升',
        0:'下降',
        2:'持平'
      }
      return `${require(`@/assets/image/situation/${this.imgSize}${this.imgName?this.imgName:''}${typeMap[this.flag]}.png`)}?${time}`
    },
    computedStopImg(){
      if(this.stopImg) {
        if(this.stopImg ==='/') return ''
         return `${require(`@/assets/image/${this.stopImg}`)}`
      }else{
        const typeMap ={
          1:'上升',
          0:'下降',
          2:'持平'
        }
        return `${require(`@/assets/image/situation/${this.imgSize}${this.imgName?this.imgName:''}${typeMap[this.flag]}定格.png`)}`
        
      }
    }
  },
  watch:{
    flag(newVal){
      if(this.startTime){
        this.imgSrc =this.immediately?this.computedUrl(): this.computedStopImg()//定格图片

      }else{
        this.imgSrc = this.computedUrl()
      }
   
    },
  },
  mounted(){
    if(this.startTime){ //开始时间
      
      this.imgSrc =this.immediately?this.computedUrl(): this.computedStopImg()//定格图片
      console.log(  this.imgSrc,this.startTime ,'定格地址')
    
      setTimeout(()=>{
        this.imgSrc = this.computedUrl()
        let timer =  setInterval(()=>{
            if(this.playCount&&(this.count>=this.playCount)){ //设置循环次数
              timer = null 
              return
            }
            this.imgSrc = this.computedUrl()
            this.count = this.count+1
          },this.duration)
         },this.startTime)

    }else{
      this.imgSrc = this.computedUrl()
      let timer =  setInterval(()=>{
        if(this.playCount&&(this.count>=this.playCount)){ //设置循环次数
          timer = null 
          return
        }
        this.imgSrc = this.computedUrl()
        this.count = this.count+1
      },this.duration)
    }

    if(!this.duration) return //间隔设为0就不刷新
  
    
  }
}
</script>